module.exports = __webpack_public_path__ + "img/goods_1.8b089dd8.jpg";